import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    createBrowserRouter,
    RouterProvider,
    BrowserRouter
} from "react-router-dom";
import "./index.css";
import routes from "./routes/routes";

import { AuthProvider } from "react-oidc-context";
import {OidcClientSettings} from "oidc-client-ts";

require('dotenv').config()



// https://authts.github.io/oidc-client-ts/

// @ts-ignore
const oidcConfig = {
    onSigninCallback: async (user: any) => {
        //alert('You just signed in. DO NOT forget log out after doing your job, otherwise your account can be compromised !!!');
        //console.log(user);
        window.location.hash = '';
        window.history.replaceState( {},document.title,window.location.pathname )
    },
    authority: process.env.REACT_APP_MIKE_SSO_AUTHORITY!,
    client_id:   "schk-password",
    responseType: 'id_token',

    redirect_uri:   process.env.REACT_APP_REDIRECT_URL !,

    // doplnene
    automaticSilentRenew: true,
};


console.log("MIKE ENV:: "+process.env.NODE_ENV)
console.log("MIKE ENV:: PUBLIC_URL :: "+process.env.PUBLIC_URL)
console.log("MIKE ENV:: REACT_APP_MIKE_MIDPOINT_SERVICE_ENDPOINT :: "+process.env.REACT_APP_MIKE_MIDPOINT_SERVICE_ENDPOINT)



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <AuthProvider {...oidcConfig} >
            <RouterProvider router={routes}/>
        </AuthProvider>

    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
